var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "card w-modal h-modal", attrs: { id: "donation-payment" } },
    [
      _c("div", { staticClass: "header" }, [
        _vm._m(0),
        _c(
          "div",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [_c("i", { staticClass: "icn icn-x sm" })]
        )
      ]),
      _vm.payload.donation.paymentType == _vm.directDebit
        ? _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "flex flex-col items-center" }, [
              _c("img", {
                staticClass: "h-40 mb-10 mt-20",
                attrs: { src: require("@/assets/img/process_icon.svg") }
              }),
              _c("h1", { staticClass: "mb-10" }, [
                _vm._v(
                  "Donation #" +
                    _vm._s(_vm.payload.transaction.receiptNumber) +
                    " is under process"
                )
              ]),
              _c("h1", [
                _vm._v("The receipt will be sent when the payment is verified")
              ])
            ])
          ])
        : _vm._e(),
      _vm.payload.donation.paymentType == _vm.creditCard
        ? _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "flex flex-col items-center" }, [
              _c("img", {
                staticClass: "h-40 mb-10 mt-20",
                attrs: { src: require("@/assets/img/tick_icon.svg") }
              }),
              _c("h1", { staticClass: "mb-10" }, [
                _vm._v("Payment accepted successfully")
              ]),
              _c("h1", [
                _vm._v(
                  "Donation #" +
                    _vm._s(_vm.payload.transaction.receiptNumber) +
                    " has been processed"
                )
              ])
            ]),
            !_vm.emailIsSent
              ? _c("div", { staticClass: "field mt-10" }, [
                  _c("form", { attrs: { id: "sending-receipt" } }, [
                    _vm.payload.billingAddress.postalCode
                      ? _c("div", { staticClass: "row mt-2" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sendPost,
                                    expression: "sendPost"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.sendPost)
                                    ? _vm._i(_vm.sendPost, null) > -1
                                    : _vm.sendPost
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.sendPost,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.sendPost = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.sendPost = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.sendPost = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                " Send the " +
                                  _vm._s(
                                    _vm.payload.donation.type === "Single"
                                      ? "receipt"
                                      : "confirmation"
                                  ) +
                                  " via post to " +
                                  _vm._s(_vm.payload.addressFullLine) +
                                  " "
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.payload.sendReceiptToEmail,
                                expression: "payload.sendReceiptToEmail"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.payload.sendReceiptToEmail
                              )
                                ? _vm._i(_vm.payload.sendReceiptToEmail, null) >
                                  -1
                                : _vm.payload.sendReceiptToEmail
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = _vm.payload.sendReceiptToEmail,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.payload,
                                          "sendReceiptToEmail",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.payload,
                                          "sendReceiptToEmail",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.payload,
                                      "sendReceiptToEmail",
                                      $$c
                                    )
                                  }
                                },
                                function($event) {
                                  return _vm.checkCurrentEmail()
                                }
                              ]
                            }
                          }),
                          _vm._v(
                            " Send the " +
                              _vm._s(
                                _vm.payload.donation.type === "Single"
                                  ? "receipt"
                                  : "confirmation"
                              ) +
                              " via email "
                          )
                        ])
                      ])
                    ]),
                    _vm.payload.sendReceiptToEmail
                      ? _c("div", [
                          _vm.payload.supporter.email
                            ? _c("div", { staticClass: "row mt-2 ml-4" }, [
                                _c("div", { staticClass: "field" }, [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.useCurrentEmail,
                                          expression: "useCurrentEmail"
                                        }
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.useCurrentEmail
                                        )
                                          ? _vm._i(_vm.useCurrentEmail, null) >
                                            -1
                                          : _vm.useCurrentEmail
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.useCurrentEmail,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.useCurrentEmail = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.useCurrentEmail = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.useCurrentEmail = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(
                                      " Send to email " +
                                        _vm._s(_vm.payload.supporter.email) +
                                        " "
                                    )
                                  ])
                                ])
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "row mt-2 ml-4" }, [
                            _c("div", { staticClass: "field" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.useDifferentEmail,
                                      expression: "useDifferentEmail"
                                    }
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.useDifferentEmail
                                    )
                                      ? _vm._i(_vm.useDifferentEmail, null) > -1
                                      : _vm.useDifferentEmail
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.useDifferentEmail,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.useDifferentEmail = $$a.concat(
                                              [$$v]
                                            ))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.useDifferentEmail = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.useDifferentEmail = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" Send to a different email ")
                              ])
                            ])
                          ]),
                          _vm.useDifferentEmail
                            ? _c("div", { staticClass: "row mt-2 ml-4" }, [
                                _c("div", { staticClass: "field" }, [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.differentEmail,
                                          expression: "differentEmail"
                                        }
                                      ],
                                      attrs: {
                                        type: "text",
                                        placeholder: "Email"
                                      },
                                      domProps: { value: _vm.differentEmail },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.differentEmail =
                                            $event.target.value
                                        }
                                      }
                                    })
                                  ])
                                ])
                              ])
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm.emailIsSent
              ? _c(
                  "div",
                  { staticClass: "field mt-10" },
                  [_c("alert", { attrs: { message: _vm.message } })],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _c("div", { staticClass: "footer" }, [
        !_vm.isLoading &&
        _vm.payload.sendReceiptToEmail &&
        !_vm.emailIsSent &&
        ((_vm.useDifferentEmail && _vm.differentEmail) ||
          (_vm.useCurrentEmail && _vm.payload.supporter.email))
          ? _c(
              "button",
              {
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.sendEmail()
                  }
                }
              },
              [_vm._v(" Send email ")]
            )
          : _vm._e(),
        _vm.isLoading && !_vm.emailIsSent
          ? _c(
              "button",
              { staticClass: "secondary", attrs: { type: "button" } },
              [
                _c("img", {
                  staticClass: "h-6",
                  attrs: { src: require("@/assets/img/spinning.svg") }
                })
              ]
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "flex flex-col" }, [
        _c("h1", { staticClass: "mb-2" }, [_vm._v("New Donation")]),
        _c("div", { staticClass: "flex flex-row" }, [
          _c("h4", { staticClass: "opacity-50" }, [
            _vm._v("Supporter Details")
          ]),
          _c("h4", { staticClass: "ml-4 mr-4 opacity-50" }, [_vm._v(">")]),
          _c("h4", { staticClass: "opacity-50" }, [_vm._v("Donation Details")]),
          _c("h4", { staticClass: "ml-4 mr-4 opacity-50" }, [_vm._v(">")]),
          _c("h4", { staticClass: "opacity-50" }, [_vm._v("Payment")]),
          _c("h4", { staticClass: "ml-4 mr-4" }, [_vm._v(">")]),
          _c("h4", [_vm._v("Receipt")])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }